"use client";
import Image from "next/image";
import { NextPage } from "next/types";
import { useState, useEffect, useRef, useContext } from "react";
import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl, { LngLatLike } from "mapbox-gl";
import MapboxLanguage from "@mapbox/mapbox-gl-language";

import { SiteHeader } from "@/components/site-header";
import { SiteFooter } from "@/components/site-footer";

import { cn } from "@/lib/utils";
import contactStyle from "./style.module.scss";
import { companyInfoList, contactList } from "@/config/site";
import { DeviceTypeContext } from "@/lib/isMobile";

mapboxgl.accessToken =
  "pk.eyJ1Ijoiamxha2UwMTA3IiwiYSI6ImNsbDUxZ243MjA0aHozZW96d3B3d2JhYjMifQ.Jycs-gHVqwfO6g7B4hiHRw";

const ContactPage: NextPage = () => {
  const deviceType = useContext(DeviceTypeContext);

  const [curLocIdx, setCurLocIdx] = useState(0);
  let map = useRef<mapboxgl.Map>();
  let marker = useRef<mapboxgl.Marker>();
  let popup = useRef<mapboxgl.Popup>();
  useEffect(() => {
    handleLocClick(curLocIdx);
  }, []);

  const getInitial = () => {
    return new Promise<void>((resolve) => {
      if (map.current) return resolve();
      const language = new MapboxLanguage({
        defaultLanguage: "zh-Hans",
      });
      map.current = new mapboxgl.Map({
        container: "map", // container ID
        style: "mapbox://styles/mapbox/streets-v12", // style URL
        zoom: 14,
      });
      map.current.addControl(language);
      marker.current = new mapboxgl.Marker({
        color: "red",
        scale: 0.5,
      });
      popup.current = new mapboxgl.Popup({
        closeOnClick: false,
        closeButton: false,
        offset: 12,
      });

      resolve();
    });
  };
  const handleLocClick = async (idx: number) => {
    await getInitial();

    setCurLocIdx(idx);

    const locInfo = companyInfoList[idx];
    map.current!.setCenter(locInfo.loc as LngLatLike);
    marker.current!.setLngLat(locInfo.loc as LngLatLike).addTo(map.current!);
    popup
      .current!.setLngLat(locInfo.loc as LngLatLike)
      .setHTML(locInfo.subTitle)
      .addTo(map.current!);

    map.current!.resize();
  };

  return (
    <main className="w-full bg-white">
      <section>
        {/* bg-[url('/banner/banner7.png')]
              bg-[length:100%_100%] bg-center  bg-no-repeat */}
        <div className="w-full bg-white relative">
          {deviceType.isMobile ? (
            <Image
              src="/mobile/banner/banner7.png"
              className="w-full h-full"
              width="750"
              height="600"
              quality={100}
              alt="banner6"
              priority
            />
          ) : (
            <>
              <div
                className="container absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] text-white text-start
                  space-y-6 "
              >
                <h2 className="text-4xl font-bold">联系我们</h2>
              </div>
              <Image
                src="/banner/banner7.png"
                className="w-full h-[360px] object-cover object-center"
                width="2560"
                height="360"
                quality={100}
                alt="banner7"
                priority
              />
            </>
          )}
          {/* <div className="container mx-auto space-y-6 pt-40 h-full relative">
              <p className="text-white text-4xl font-bold">联系我们</p>
              <p className="text-white text-xl font-normal">欢迎联系我们</p>
            </div> */}
        </div>
      </section>
      <section>
        <div className="container text-center text-[#333333] pt-6 md:py-24">
          <>
            <h4 className="text-3xl md:text-4xl mb-6 md:mb-12">联系方式</h4>

            <div className="flex flex-col md:flex-row space-y-6 md:space-y-0">
              {contactList.map((item, idx) => (
                <div className="flex-center flex-col flex-1" key={idx}>
                  <div className="w-24 h-24 rounded-full p-6 bg-white border border-slate-300">
                    <Image
                      className="w-full h-full"
                      src={`/intro/contact/contact${idx + 1}.png`}
                      alt="contact"
                      width="133"
                      height="133"
                      quality={100}
                    />
                  </div>
                  <p className="text-lg mt-2 md:mt-4 ">{item.value}</p>
                  <p className="text-lg">{item.title}</p>
                </div>
              ))}
            </div>
          </>

          <>
            <h4 className="text-3xl my-6 md:mb-12 md:mt-24">办公地址</h4>
            <div className="flex flex-col md:flex-row h-[400px] md:h-full">
              <div className="flex flex-row md:flex-col w-full md:w-[33%] items-center  bg-[#f5f7fa] md:bg-white">
                {companyInfoList.map(({ label, title }, idx) => (
                  <div
                    key={idx}
                    className={cn(
                      "p-4 md:p-6 flex flex-col items-start cursor-pointer md:w-full",
                      curLocIdx === idx
                        ? "text-white bg-[#004EA2] flex-1 md:flex-grow-0"
                        : "text-[#333333]"
                    )}
                    onClick={() => handleLocClick(idx)}
                  >
                    <h4 className="text-xl">{label}</h4>
                    <div
                      className={cn(
                        curLocIdx === idx ? "block" : "hidden",
                        "md:block"
                      )}
                    >
                      <hr className="w-full my-2" />
                      <p className=" text-xs md:text-sm text-left">{title} </p>
                    </div>
                  </div>
                ))}
              </div>
              {/**地图 */}
              <div
                id="map"
                className={cn(
                  "md:border md:border-[#B0B4B9]  h-96 flex-1 w-full",
                  contactStyle.mapBox
                )}
              ></div>
            </div>
          </>
        </div>
      </section>
    </main>
  );
};

export default ContactPage;
